/**
 * Where a notification takes you when you click it.
 *
 * The server stores `entity_type` + `entity_id` and the event payload, never a
 * URL — routes are the SPA's business, and a path baked into a row years ago
 * outlives the screen it pointed at. This is the one place that maps the two.
 *
 * Returns null when there is nowhere useful to go; the caller then treats the
 * click as mark-read only.
 *
 * @param {{entity_type?: string, entity_id?: string, details?: object}} notification
 * @returns {string|null}
 */
export const notificationLink = (notification) => {
  const entityId = notification?.entity_id;
  const details = notification?.details ?? {};
  const jobId = details.job_id || (notification?.entity_type === "job" ? entityId : null);
  const candidateId = details.candidate_id || (notification?.entity_type === "candidate" ? entityId : null);

  switch (notification?.entity_type) {
    case "job":
      return jobId ? `/admin/job-detail/${jobId}` : null;

    // The candidate page loads nothing without `?job_id=`: a candidate is read
    // through one of their applications. Every candidate and application event
    // carries the job in its payload.
    case "candidate":
    case "application":
      if (!candidateId) return null;
      return jobId ? `/admin/candidate-analysis/${candidateId}?job_id=${jobId}` : `/admin/candidate-analysis/${candidateId}`;

    // The batch's own review screen is gone once the batch is confirmed, and
    // "confirmed" is the only state this notification is written in. The job
    // the resumes landed on is what the recruiter actually wants to see.
    case "bulk_batch":
      return jobId ? `/admin/job-detail/${jobId}` : null;

    default:
      return null;
  }
};

export default notificationLink;
